export default __webpack_public_path__ + "static/media/doughnut-2.3e39ced5.jpeg";